$(document).ready(function () {
  function validateField(field) {
    var validation = false;
    if (field.attr("type") == "email") {
      validation = validateEmail(field);
    } else if (field.attr("type") == "password") {
      if (!field.hasClass("confirm-password")) {
        validation = validatePassword(field);
      } else {
        validation = validateConfirmPassword(field);
      }
    } else if (field.attr("type") == "text") {
      if (field.hasClass("website-validation")) {
        validation = validateWebsite(field);
      } else {
        validation = validateText(field);
      }
    } else if (field[0]["localName"] === "textarea") {
      validation = validateTextarea(field);
    } else if (field[0]["localName"] === "select") {
      validation = validateSelect(field);
    } else if (field.attr("type") == "tel") {
      validation = validatePhone(field);
    } else if (field.attr("type") == "checkbox") {
      validation = validateCheckbox(field);
    } else if (field.attr("type") == "file") {
      validation = validateFileUpload(field);
    } else if (field.attr("name") == "fax") {
      validation = validateFax(field);
    } else if (field.attr("type") == "number") {
      validation = validateNumber(field);
    }

    if (validation) {
      field.next(".form-validation-error").remove();
    }
    return validation;
  }

  function validateEmail(field) {
    if (!emptyCheck(field)) return !1;
    const email = field.val();
    function invalidEmail() {
      (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Please enter a valid email address</span>',
        ).insertAfter(field));
    }
    const emailParts = email.split("@");
    if (emailParts.length != 2) return (invalidEmail(), !1);
    const localPart = emailParts[0],
      domainPart = emailParts[1];
    if (
      !/^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*$/.test(
        localPart,
      ) ||
      localPart.length > 64 ||
      localPart.startsWith(".") ||
      localPart.endsWith(".") ||
      localPart.includes("..") ||
      domainPart.includes("--") ||
      domainPart.startsWith("-") ||
      domainPart.endsWith("-") ||
      domainPart.length > 255
    )
      return (invalidEmail(), !1);
    const tldRegex = /^[a-zA-Z]{2,}$/,
      domainParts = domainPart.split("."),
      domainNameRegex = /^[a-zA-Z0-9]+([-][a-zA-Z0-9]+)*$/;
    if (
      !domainNameRegex.test(domainParts[0]) ||
      domainParts.length < 2 ||
      !tldRegex.test(domainParts[domainParts.length - 1])
    )
      return (invalidEmail(), !1);
    for (let i = 0; i < domainParts.length - 1; i++)
      if (!domainNameRegex.test(domainParts[i])) return (invalidEmail(), !1);
    if (field.parents(".wac-login").length) {
      field.next(".form-validation-error").remove();
      let isValid = !1;
      return (
        $.ajax({
          type: "GET",
          url: `${applicationUrl}/api/partner`,
          data: { email },
          async: !1,
          success: function (data) {
            data
              ? ($(
                  '<span class="form-validation-error">Email already exists. Please use a different email.</span>',
                ).insertAfter(field),
                (isValid = !1))
              : (console.log("emailcheck false"),
                field.next(".form-validation-error").remove(),
                (isValid = !0));
          },
        }),
        isValid
      );
    } else return (field.next(".form-validation-error").remove(), !0);
  }
 function validatePassword(field) {

  // ===== LOGIN PAGE =====
  if (field.attr("id") === "CustomerPassword") {
    return emptyCheck(field); // only required validation
  }

  // ===== REGISTER PAGE ONLY BELOW =====
  if (!emptyCheck(field)) return false;

  const password = field.val();
  field.next(".form-validation-error").remove();

  // length check
  if (password.length < 8 || password.length > 40) {
    $(
      '<span class="form-validation-error">Password must be between 8 and 40 characters.</span>'
    ).insertAfter(field);
    return false;
  }

  // uppercase check
  if (!/[A-Z]/.test(password)) {
    $(
      '<span class="form-validation-error">Password must contain at least 1 uppercase letter.</span>'
    ).insertAfter(field);
    return false;
  }

  // lowercase check
  if (!/[a-z]/.test(password)) {
    $(
      '<span class="form-validation-error">Password must contain at least 1 lowercase letter.</span>'
    ).insertAfter(field);
    return false;
  }

  // number check
  if (!/[0-9]/.test(password)) {
    $(
      '<span class="form-validation-error">Password must contain at least 1 number.</span>'
    ).insertAfter(field);
    return false;
  }

  // special char check
  if (!/[@$!%*?&^#()_\-+=]/.test(password)) {
    $(
      '<span class="form-validation-error">Password must contain at least 1 special character.</span>'
    ).insertAfter(field);
    return false;
  }

  field.next(".form-validation-error").remove();
  return true;
}
  function validateConfirmPassword(field) {
    return field.val() != "" &&
      field.val() != field.closest("form").find("#password").val()
      ? (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Password does not match.</span>',
        ).insertAfter(field),
        !1)
      : emptyCheck(field);
  }
  function validateText(field) {
    return field.val().length < 3 &&
      field.val() !== "" &&
      field.hasClass("min-3-characters")
      ? (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Please enter at least 3 characters</span>',
        ).insertAfter(field),
        !1)
      : field.val().length > 40 &&
          field.val() !== "" &&
          field.hasClass("max-40-characters")
        ? (field.val(field.val().substring(0, 40)),
          field.next(".form-validation-error").remove(),
          $(
            '<span class="form-validation-error">Maximum of 40 characters allowed</span>',
          ).insertAfter(field),
          !1)
        : field.val().length > 100 &&
            field.val() !== "" &&
            field.hasClass("max-100-characters")
          ? (field.val(field.val().substring(0, 100)),
            field.next(".form-validation-error").remove(),
            $(
              '<span class="form-validation-error">Maximum of 100 characters allowed</span>',
            ).insertAfter(field),
            !1)
          : field.val().length > 255 &&
              field.val() !== "" &&
              field.hasClass("max-255-characters")
            ? (field.val(field.val().substring(0, 255)),
              field.next(".form-validation-error").remove(),
              $(
                '<span class="form-validation-error">Maximum of 255 characters allowed</span>',
              ).insertAfter(field),
              !1)
            : emptyCheck(field);
  }
  function validateWebsite(field) {
    let website = field.val();
    return website.length > 255
      ? (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Website URL must be at most 255 characters</span>',
        ).insertAfter(field),
        !1)
      : /^(https?:\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/.test(
            website,
          )
        ? (field.next(".form-validation-error").remove(), !0)
        : (field.next(".form-validation-error").remove(),
          $(
            '<span class="form-validation-error">Please enter a valid URL</span>',
          ).insertAfter(field),
          !1);
  }
  function validateSelect(field) {
    
  // 🔴 treat --- as empty (country default option)
  if (field.val() === '---') {
    field.val('');
  }
    return emptyCheck(field);
  }
  function validatePhone(field) {
    if (!emptyCheck(field)) return !1;
    const phone = field.val();
    function invalidPhone() {
      (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Please enter a valid phone number</span>',
        ).insertAfter(field));
    }
    if (phone.length < 6 || phone.length > 14) return (invalidPhone(), !1);
    if (field.parents(".wac-company").length) {
      field.next(".form-validation-error").remove();
      let isValid = !1;
      return (
        $.ajax({
          type: "GET",
          url: `${applicationUrl}/api/partner`,
          data: { phone },
          async: !1,
          success: function (data) {
            data
              ? ($(
                  '<span class="form-validation-error">Phone number already exists. Please use a different phone number.</span>',
                ).insertAfter(field),
                (isValid = !1))
              : (field.next(".form-validation-error").remove(), (isValid = !0));
          },
        }),
        isValid
      );
    } else return (field.next(".form-validation-error").remove(), !0);
  }
  function validateFax(field) {
    if (!emptyCheck(field)) return !1;
    let fax = field.val();
    function invalidFax() {
      (field.next(".form-validation-error").remove(),
        $(
          '<span class="form-validation-error">Please enter a valid fax number</span>',
        ).insertAfter(field));
    }
    return fax.length < 7 || fax.length > 20
      ? (invalidFax(), !1)
      : /^(\+?\d{1,4})?[\s-]?(\(?\d{2,4}\)?)?[\s-]?\d{3,4}[\s-]?\d{4}$/.test(
            fax,
          )
        ? (field.next(".form-validation-error").remove(), !0)
        : (invalidFax(), !1);
  }
  function validateNumber(field) {
    return emptyCheck(field);
  }
  function validateCheckbox(field) {
    return emptyCheck(field);
  }
  function validateFileUpload(field) {
    if (!emptyCheck(field)) return !1;
    if (field[0].files.length != 0) {
      var fileName = field[0].files[0].name,
        uploadFileName = field.closest(".upload-wrapp").find(".upload-text");
      if (fileName != "") {
        (uploadFileName.text(fileName),
          uploadFileName.addClass("upload-text-color"));
        var fileSize = field[0].files[0].size,
          fileSizeMB = fileSize / (1024 * 1024);
        return fileSizeMB > 2
          ? (field.next(".form-validation-error").remove(),
            $(
              '<span class="form-validation-error">The uploaded file is too large.</span>',
            ).insertAfter(field),
            !1)
          : !0;
      }
    }
  }

  $(
    "#ContactForm input, .add-new-address input, .edit-address input, #newsletter-section input, #create_customer input, #customer_login input, #RecoverPasswordForm form input",
  ).on("input keypress", function (e) {
    let trimmedValue = $(this).val().trim(),
      inputValue = $(this).val();
    if (
      (trimmedValue.replace(/\s/g, "").length || $(this).val(""),
      e.key === " " &&
        trimmedValue.length === 0 &&
        (e.preventDefault(), $(this).val("")),
      trimmedValue.length < inputValue.length &&
        /^\s/.test(inputValue) &&
        $(this).val(trimmedValue),
      $(this).attr("type") === "tel" || $(this).attr("type") === "number")
    ) {
      let trimmedValue2 = $(this).val().trim(),
        isNumber = /[0-9\-+]/.test(e.key);
      (!isNumber &&
        trimmedValue2.length === 0 &&
        (e.preventDefault(), $(this).val("")),
        isNumber || e.preventDefault());
    }
    if (
      $(this).attr("type") === "text" &&
      $(this).attr("data-field") !== "zip"
    ) {
      // allow only letters + space ALWAYS
      if (
        !/^[a-zA-Z\s]$/.test(e.key) &&
        e.key.length === 1 && // ignore control keys
        !e.ctrlKey &&
        !e.metaKey
      ) {
        e.preventDefault();
      }
    }

    var myArray = ["password", "file"];
    if ($.inArray($(this).attr("type"), myArray) != 0) {
      var sanitizedValue = inputValue.replace(/\s{2,}/g, " ");
      $(this).val(sanitizedValue);
    }
    $(this).hasClass("required")
      ? $(this).val() == ""
        ? emptyCheck($(this))
        : ($(this).next(".form-validation-error").remove(),
          $(this).attr("type") === "email"
            ? validateEmail($(this))
            : $(this).attr("type") === "tel"
              ? validatePhone($(this))
              : $(this).attr("type") === "text"
                ? $(this).hasClass("website-validation")
                  ? validateWebsite($(this))
                  : validateText($(this))
                : $(this).attr("type") == "file"
                  ? validateFileUpload($(this))
                  : $(this).attr("type") == "password"
                    ? $(this).hasClass("confirm-password")
                      ? validateConfirmPassword($(this))
                      : validatePassword($(this))
                    : $(this).attr("type") == "number" &&
                      validateNumber($(this)))
      : !$(this).hasClass("required") &&
        $(this).val() !== "" &&
        ($(this).attr("type") === "email"
          ? validateEmail($(this))
          : $(this).attr("type") === "tel"
            ? validatePhone($(this))
            : $(this).attr("type") === "text"
              ? validateText($(this))
              : $(this).attr("type") == "file"
                ? validateFileUpload($(this))
                : $(this).attr("name") == "fax"
                  ? validateFax($(this))
                  : $(this).attr("type") == "number" &&
                    validateNumber($(this)));
  });

  $(
    '#ContactForm button[type="submit"], .edit-address input[type="submit"], .add-new-address input[type="submit"], #newsletter-section button[type="submit"], #create_customer button[type="submit"], #customer_login button[type="submit"], #RecoverPasswordForm form input[type="submit"]',
  ).on("click", function (e) {
    var validated = false;
    var validationSuccess = true;
    var flag = 0;

    $(this)
      .closest("form")
      .find(
        'input.required:not([type="hidden"]):not([type="submit"]), textarea.required, select.required',
      )
      .each(function () {
        validated = validateField($(this));
        if (!validated) {
          validationSuccess = false;
          if (flag == 0) {
            $(this).focus();
            flag = 1;
          }
        }
      });

    if (!validationSuccess) {
      e.preventDefault();
    }
  });
  ($(
    "input:not([type='file']).required, select.required, textarea.required",
  ).on("focusout", function () {
    emptyCheck($(this));
  }),
    $("select").on("change", function () {
      $(this).val() !== "" && $(this).next(".form-validation-error").remove();
    }));
  function emptyCheck(field) {
    let fieldName = "";
    return (
      (fieldName = field.attr("data-label")),
      ((field[0].localName === "select" &&
        field.attr("multiple") == "multiple" &&
        field.val().length == 0) ||
        field.val() === "" ||
        field.val() === null) &&
      field.hasClass("required")
        ? (field.next(".form-validation-error").remove(),
          fieldName && (fieldName = fieldName.replace("*", "")),
          $(
            '<span  role="alert" aria-live="assertive" class="form-validation-error" role="alert" aria-live="assertive">' +
              fieldName +
              " is required</span>",
          ).insertAfter(field),
          !1)
        : !0
    );
  }
  $(".user-logout").on("click", function (event) {
    var confirmation = confirm("Are you sure you want to log out?");
    confirmation || event.preventDefault();
  });

  //   $(document).on('click', '.remove-cart-item', function (event) {
  //     var confirmation = confirm(
  //       'Are you sure you want to remove this item from the cart?'
  //     )
  //     confirmation || event.preventDefault()
  // });
});

/* =====================================
   EMAIL FIELD CHARACTER RESTRICTION

===================================== */

$(document).on("keypress", 'input[type="email"]', function (e) {
  const allowedChars = /^[a-zA-Z0-9@._+-]$/;

  // Allow control keys (backspace, arrows, tab, delete)
  if (e.ctrlKey || e.metaKey || e.key.length !== 1) {
    return;
  }

  if (!allowedChars.test(e.key)) {
    e.preventDefault();
  }
});

$(document).on("input", 'input[type="email"]', function () {
  const sanitizedValue = $(this)
    .val()
    .replace(/[^a-zA-Z0-9@._+-]/g, "");

  if ($(this).val() !== sanitizedValue) {
    $(this).val(sanitizedValue);
  }
});

/* =====================================
   PHONE ZERO / REPEATED DIGIT GUARD
 
===================================== */

// Detect spam phone numbers like 0000000 or 1111111
function isSpamPhoneNumber(phone) {
  const digits = phone.replace(/\D/g, "");

  // All zeros
  if (/^0+$/.test(digits)) return true;

  // Same digit repeated
  if (/^(\d)\1+$/.test(digits)) return true;

  return false;
}

// Remove spam error once user corrects input
$(document).on("input", 'input[type="tel"]', function () {
  if (!isSpamPhoneNumber($(this).val())) {
    $(this).next(".form-validation-error.zero-phone-error").remove();
  }
});

// Block form submission ONLY for spam phone numbers
$(document).on(
  "click",
  '#ContactForm button[type="submit"], \
   .edit-address input[type="submit"], \
   .add-new-address input[type="submit"], \
   #newsletter-section button[type="submit"], \
   #create_customer button[type="submit"], \
   #customer_login button[type="submit"], \
   #RecoverPasswordForm form input[type="submit"]',
  function (e) {
    let blocked = false;

    $(this)
      .closest("form")
      .find('input[type="tel"].required')
      .each(function () {
        if (isSpamPhoneNumber($(this).val())) {
          $(this).next(".form-validation-error").remove();
          $(
            '<span class="form-validation-error zero-phone-error">Phone number cannot be all zeros or repeated digits</span>',
          ).insertAfter($(this));

          if (!blocked) $(this).focus();
          blocked = true;
        }
      });

    if (blocked) e.preventDefault();
  },
);

/* =====================================
   PHONE FIELD – PASTE & INPUT SANITIZER
   (PARALLEL | DOES NOT AFFECT OLD CODE)
===================================== */

(function () {
  // Handle paste: allow ONLY numbers
  $(document).on("paste", 'input[type="tel"]', function (e) {
    e.preventDefault();

    const pastedText =
      (e.originalEvent || e).clipboardData.getData("text") || "";

    const numbersOnly = pastedText.replace(/\D/g, "");

    // Insert cleaned numeric value
    if (document.queryCommandSupported("insertText")) {
      document.execCommand("insertText", false, numbersOnly);
    } else {
      // Fallback
      $(this).val($(this).val() + numbersOnly);
    }
  });

  // Handle autofill / drag / mobile paste safety
  $(document).on("input", 'input[type="tel"]', function () {
    const sanitized = $(this).val().replace(/\D/g, "");
    if ($(this).val() !== sanitized) {
      $(this).val(sanitized);
      // Re-run the field validation on the cleaned value. The validator runs
      // BEFORE this sanitizer, so a formatted entry (autofill/drag/mobile) like
      // "+91 70349 87495" (>14 chars) gets flagged "too long", then stripped to
      // a valid number here. Setting .val() doesn't fire a new input event, so
      // without this re-trigger the stale error would stick on a valid number.
      // The re-fired event is a no-op for this sanitizer (already digits-only),
      // so it can't loop.
      $(this).trigger("input");
    }
  });
})();
/* =====================================
   MESSAGE FIELD HTML BLOCK (COLLISION SAFE)
===================================== */

(function () {

  const htmlTagRegex = /<\/?[^>]+(>|$)/;
  const restrictedSymbolRegex = /[{}\[\]<>|^]/;

  const messageSelector = "#ContactForm-body";

  function showHtmlError(field) {

    // remove ONLY html error
    field.next(".html-tag-error").remove();

    // remove min-length error if present
    field.nextAll(".form-validation-error")
         .not(".html-tag-error")
         .remove();

    $('<span class="form-validation-error html-tag-error">Message contains invalid characters</span>')
      .insertAfter(field);
  }

  function removeHtmlError(field){
    field.next(".html-tag-error").remove();
  }

  /* ===== REAL TIME CHECK ===== */
  $(document).on("input paste", messageSelector, function () {

    const field = $(this);
    const value = field.val();

    if (value && (htmlTagRegex.test(value) || restrictedSymbolRegex.test(value))) {
      showHtmlError(field);
    } else {
      removeHtmlError(field);
    }
  });

  /* ===== SUBMIT BLOCK ===== */
  $(document).on("click",
    '#ContactForm button[type="submit"]',
    function (e) {

      const field = $("#ContactForm-body");
      const value = field.val();

      if (value && (htmlTagRegex.test(value) || restrictedSymbolRegex.test(value))) {

        showHtmlError(field);
        field.focus();
        e.preventDefault();
      }
  });

})();

/* =====================================
   REAL-TIME TEXTAREA CHAR VALIDATION
   min: 3 | max: 1200
   Class-based, isolated
===================================== */

$(document).on("input", "textarea.max-1200-characters", function () {
  const MIN = 3;
  const MAX = 1200;
  const $field = $(this);
  const value = $field.val();
  const length = value.length;

  // Remove only this field's error
  $field.next(".form-validation-error").remove();

  // Max check (hard stop)
  if (length > MAX) {
    $field.val(value.substring(0, MAX));
    $(
      '<span class="form-validation-error">Maximum of 1200 characters allowed</span>',
    ).insertAfter($field);
    return;
  }

  // Min check (real-time)
  if (length > 0 && length < MIN) {
    $(
      '<span class="form-validation-error">Please enter at least 3 characters</span>',
    ).insertAfter($field);
    return;
  }
});

/* =====================================
   DISABLE SUBMIT WHILE ANY ERROR IS SHOWN
   (#ContactForm) — keeps the send button
   disabled whenever a validation error
   message is visible; re-enables when none.
===================================== */
(function () {
  const form = document.getElementById("ContactForm");
  if (!form) return;

  const submitBtn = form.querySelector(
    'button[type="submit"], input[type="submit"]',
  );
  if (!submitBtn) return;

  function refreshSubmitState() {
    // Any client-side validation message (phone/email/name/message/spam/html)
    // shares the .form-validation-error class.
    const hasError = form.querySelector(".form-validation-error") !== null;
    submitBtn.disabled = hasError;
    submitBtn.classList.toggle("disabled", hasError);
  }

  // React whenever an error span is added or removed anywhere in the form.
  // MutationObserver batches add+remove pairs into one callback, so we always
  // settle on the final state (no flicker) and never loop.
  new MutationObserver(refreshSubmitState).observe(form, {
    childList: true,
    subtree: true,
  });

  // Correct state on initial load.
  refreshSubmitState();
})();

/* =====================================
   CART REMOVE BUTTON
===================================== */

// CAPTURE phase (the `true` below) is required, for the same reason as the minus
// button handler further down. theme.js binds `$(document).on('click',
// '.js-remove-mini-cart')`, a jQuery delegate — i.e. a BUBBLE listener on
// document — and it is registered first (header-js.liquid loads theme.js before
// layout/theme.liquid loads this file). On the bubble, theme.js therefore ran
// FIRST: it faded the row out and posted Shopify.changeItem(id, 0) before this
// confirm() appeared, so the item was already gone and cancelling did nothing.
// In capture we run before any bubble listener, and stopImmediatePropagation()
// genuinely prevents theme.js from firing when the shopper cancels.
document.addEventListener(
  "click",
  function (e) {
    /* REMOVE BUTTON CLICK */
    if (e.target.closest(".js-remove-mini-cart")) {
      const confirmRemove = confirm(
        "Are you sure you want to remove this item from cart?",
      );

      if (!confirmRemove) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }
  },
  true,
);

// CAPTURE phase (the `true` below) is required. theme.js binds its own minus
// handler directly on the button, which runs in the TARGET phase — before any
// bubble-phase document listener. If this ran on the bubble (the old behaviour),
// theme.js had already decremented the input and posted the change by the time
// we read input.value, so at qty 2 it read "1", popped the "remove?" confirm one
// step too early, and cancelling it did nothing (theme.js had already acted).
// Running in capture, we read the pre-click value and stopImmediatePropagation
// truly prevents theme.js from firing when the shopper cancels.
document.addEventListener(
  "click",
  function (e) {
    /* MINUS BUTTON */
    if (e.target.closest(".js-qty__minus")) {
      const input = e.target.closest(".js-qty").querySelector(".js-qty__input");

      // Only confirm when this click would actually remove the line (qty 1 -> 0).
      if (input && parseInt(input.value) <= 1) {
        const confirmRemove = confirm(
          "Are you sure you want to remove this item from cart?",
        );

        if (!confirmRemove) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      }
    }
  },
  true,
);

/* =========================================
   SEARCH CURSOR DELAY 1s + iPAD KEYBOARD FIX
   parallel safe code
========================================= */

document.addEventListener("click", function (e) {
  var openBtn = e.target.closest(".modal__toggle-open");
  var mobileBtn = e.target.closest(".modal__toggle-search-mobile");
  var closeBtn = e.target.closest(".search-modal__close-button");
  var overlay = e.target.closest(".modal-overlay");

  var input = document.getElementById("Search-In-Modal");
  if (!input) return;

  /* ---------- OPEN SEARCH ---------- */
  if (openBtn || mobileBtn) {
    // Touch (iPhone/iPad): iOS only shows the cursor + keyboard for a focus()
    // made inside the tap itself — the blur + 1s re-focus below runs from a
    // timer, which iOS ignores, so the field opened without a cursor. Focus
    // once, now, and keep it. preventScroll: the panel is still sliding in.
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) {
      input.focus({ preventScroll: true });
      return;
    }

    // step 1: instant focus (required for iOS keyboard permission)
    input.focus();

    // step 2: remove cursor temporarily
    input.blur();

    // step 3: show cursor after 1 sec
    setTimeout(function () {
      input.focus();

      // place cursor at end properly
      var val = input.value;
      input.value = "";
      input.value = val;
    }, 1000); // 1 second delay
  }

  /* ---------- CLOSE SEARCH ---------- */
  if (closeBtn || overlay) {
    input.blur();

    // force keyboard close for iPad safari
    setTimeout(function () {
      input.setAttribute("readonly", "readonly");
      input.blur();
      input.removeAttribute("readonly");
    }, 10);
  }
});

/* ===============================
   PRODUCT SHARE BUTTON
================================*/
document.addEventListener("DOMContentLoaded", function () {
  var shareBtn = document.querySelector(".product-share-btn");
  if (!shareBtn) return;

  shareBtn.addEventListener("click", function () {
    var productUrl = window.location.href;
    var productTitle = document.title;

    // If browser supports native share
    if (navigator.share) {
      navigator
        .share({
          title: productTitle,
          text: "Check out this product",
          url: productUrl,
        })
        .catch(function (err) {
          console.log("Share cancelled", err);
        });
    } else {
      // Fallback: copy link
      navigator.clipboard.writeText(productUrl).then(function () {
        alert("Product link copied!");
      });
    }
  });
});



/* =====================================
   PRODUCT QUANTITY – CLAMP + INLINE ERROR
   Suppresses the native (un-stylable, arrow-tailed) iOS
   "Value must be less than or equal to…" bubble and shows a
   clean inline error message below the quantity field instead,
   while keeping the quantity input within its min/max range.
   Parallel safe / isolated.
===================================== */

(function () {
  function getQtyRow(input) {
    var item = input.closest(".product-form__item--quantity");
    return item ? item.parentNode : input.parentNode;
  }

  function showQtyError(input, message) {
    var row = getQtyRow(input);
    if (!row || !row.parentNode) return;

    var err = row.parentNode.querySelector(".wac-qty-error");
    if (!err) {
      err = document.createElement("span");
      err.className = "form-validation-error wac-qty-error";
      err.setAttribute("role", "alert");
      err.setAttribute("aria-live", "assertive");
      // Insert right after the quantity row (above the buy button).
      row.insertAdjacentElement("afterend", err);
    }
    err.textContent = message;
  }

  function clearQtyError(input) {
    var row = getQtyRow(input);
    if (!row || !row.parentNode) return;
    var err = row.parentNode.querySelector(".wac-qty-error");
    if (err) err.remove();
  }

  function clampQty(input) {
    if (!input) return;

    var max = parseInt(input.getAttribute("max"), 10);
    var min = parseInt(input.getAttribute("min"), 10);
    if (isNaN(min)) min = 1;

    var value = parseInt(input.value, 10);

    // Allow the field to be temporarily empty while typing.
    if (input.value === "" || isNaN(value)) {
      clearQtyError(input);
      return;
    }

    if (!isNaN(max) && value > max) {
      input.value = max;
      showQtyError(
        input,
        "Only " + max + (max === 1 ? " item" : " items") + " available in stock.",
      );
    } else if (value < min) {
      input.value = min;
      showQtyError(input, "Quantity must be at least " + min + ".");
    } else {
      clearQtyError(input);
    }
  }

  // Clamp live while typing, and again on blur for safety.
  document.addEventListener("input", function (e) {
    if (e.target && e.target.classList.contains("product-form__quantity")) {
      clampQty(e.target);
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.classList.contains("product-form__quantity")) {
      clampQty(e.target);
    }
  });

  // Capture phase: the "invalid" event does not bubble, so catch it here to
  // suppress the native validation bubble and show our toast instead.
  document.addEventListener(
    "invalid",
    function (e) {
      if (e.target && e.target.classList.contains("product-form__quantity")) {
        e.preventDefault();
        clampQty(e.target);
      }
    },
    true,
  );
})();

/* ================================
   NAME FIELD – STRICT LETTER ONLY
   Blocks numbers + symbols typing & paste
================================ */

$(document).on("keypress", '#ContactForm-name', function (e) {
  const char = e.key;

  // Allow control keys (backspace, arrows, delete, tab, ctrl+c/v)
  if (e.ctrlKey || e.metaKey || char.length > 1) return;

  // Allow only letters + space
  if (!/^[a-zA-Z\s]$/.test(char)) {
    e.preventDefault();
  }
});


/* BLOCK INVALID PASTE */
$(document).on("paste", '#ContactForm-name', function (e) {
  e.preventDefault();

  let pasted =
    (e.originalEvent || e).clipboardData.getData("text") || "";

  // Remove everything except letters + space
  pasted = pasted.replace(/[^a-zA-Z\s]/g, "");

  // Remove multiple spaces
  pasted = pasted.replace(/\s+/g, " ").trim();

  // Insert cleaned value
  if (document.queryCommandSupported("insertText")) {
    document.execCommand("insertText", false, pasted);
  } else {
    $(this).val($(this).val() + pasted);
  }
});


/* SAFETY: if autofill or mobile paste bypass */
$(document).on("input", '#ContactForm-name', function () {
  let cleaned = $(this).val().replace(/[^a-zA-Z\s]/g, "");
  cleaned = cleaned.replace(/\s+/g, " ");

  if ($(this).val() !== cleaned) {
    $(this).val(cleaned);
  }
});



/* ---------------------------------------------------------------------------
   Rise-in for the "Shop by category" collection row. The whole row moves as one
   block — no per-tile stagger. The hidden state only exists once .wac-reveal is
   on the section, so if this never runs the cards simply render as normal
   instead of staying invisible.
   --------------------------------------------------------------------------- */
(function () {
  var sections = document.querySelectorAll(".wac-home-collection-list");
  if (!sections.length) return;

  var reduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.classList.add("wac-reveal-in");
      });
    },
    { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
  );

  sections.forEach(function (section) {
    if (!section.querySelector(".collection-card-3")) return;
    // Already on screen when this deferred script runs (on phones the row sits
    // right under the hero): hiding it now would blank tiles the visitor is
    // already looking at, then fade them back in — a visible flash, and a worse
    // Speed Index. Only rows still below the fold get the rise-in.
    if (section.getBoundingClientRect().top < window.innerHeight) return;
    section.classList.add("wac-reveal");
    observer.observe(section);
  });
})();


/* ---------------------------------------------------------------------------
   Parallax drift for the homepage full-bleed banners. Writes a pixel offset
   into --wac-bplx on each banner frame as it crosses the viewport;
   wac-styles.css consumes it (desktop only, >=992px).

   The offset eases toward its target rather than snapping to it, so the image
   trails the scroll and settles — that lag is what reads as smooth rather than
   mechanical. Because the easing continues after the last scroll event, the
   loop self-schedules while anything is still settling and parks itself once
   every visible frame has arrived.
   --------------------------------------------------------------------------- */
(function () {
  var frames = document.querySelectorAll(".wac-home-grid-banner .img-grid-banner");
  if (!frames.length) return;

  var reduced =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) return;

  // Must match the CSS media query — below this the desktop image is hidden.
  var desktop = window.matchMedia("(min-width: 992px)");

  // Travel as a fraction of the frame's own height. The CSS leaves 10% of
  // headroom either side, so 8% drifts visibly while keeping a margin, and it
  // scales with the frame instead of a fixed px value.
  var RANGE_RATIO = 0.08;
  // Fraction of the remaining distance covered each frame. Lower = more trail.
  var EASE = 0.08;

  var visible = [];
  var current = new WeakMap();
  var running = false;

  function start() {
    if (running) return;
    running = true;
    window.requestAnimationFrame(tick);
  }

  function tick() {
    running = false;
    var i;

    if (!desktop.matches) {
      // Below the breakpoint the CSS transform is not applied; clear any offset
      // left over from a wider viewport so nothing is stale on resize back up.
      for (i = 0; i < visible.length; i++) {
        current.set(visible[i], 0);
        visible[i].style.setProperty("--wac-bplx", "0px");
      }
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var settling = false;

    // Read every rect first, then write — interleaving the two thrashes layout.
    var targets = [];
    for (i = 0; i < visible.length; i++) {
      var rect = visible[i].getBoundingClientRect();
      // -1 while the frame sits below the fold, +1 once it has passed above it.
      var progress =
        (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      targets.push(progress * rect.height * RANGE_RATIO);
    }

    for (i = 0; i < visible.length; i++) {
      var frame = visible[i];
      var from = current.get(frame) || 0;
      var next = from + (targets[i] - from) * EASE;

      if (Math.abs(targets[i] - next) < 0.05) next = targets[i];
      else settling = true;

      current.set(frame, next);
      frame.style.setProperty("--wac-bplx", next.toFixed(2) + "px");
    }

    if (settling) start();
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var i = visible.indexOf(entry.target);
        if (entry.isIntersecting && i < 0) visible.push(entry.target);
        else if (!entry.isIntersecting && i >= 0) visible.splice(i, 1);
      });
      if (visible.length) start();
    },
    { rootMargin: "15% 0px 15% 0px" }
  );

  Array.prototype.forEach.call(frames, function (frame) {
    observer.observe(frame);
  });

  window.addEventListener("scroll", start, { passive: true });
  window.addEventListener("resize", start);
})();


/* ---------------------------------------------------------------------------
   Mobile filter drawer master-detail behaviour (paired with the CSS in
   wac-styles.css). The layout turns the drill-down <details> facets into a
   left tab strip + right options pane. This makes them behave like tabs:
   opening one filter closes the others, and the first is open by default so
   the right pane is never blank. Only runs at ≤749px; desktop drill-down and
   the facet form submission are untouched.
   --------------------------------------------------------------------------- */
(function () {
  var form = document.getElementById("FacetFiltersFormMobile");
  if (!form) return;

  var mq = window.matchMedia("(max-width: 749px)");

  function tabs() {
    return Array.prototype.filter.call(
      form.querySelectorAll(".mobile-facets__details"),
      function (d) {
        // Only real filter tabs have a submenu; the sort row has none.
        return d.querySelector(".mobile-facets__submenu");
      }
    );
  }

  function openOnly(target) {
    tabs().forEach(function (d) {
      if (d !== target) d.removeAttribute("open");
    });
  }

  // Accordion: when a filter tab opens, close the rest. Capture phase so it
  // runs alongside the theme's own toggle handling without depending on order.
  form.addEventListener(
    "toggle",
    function (e) {
      if (!mq.matches) return;
      var d = e.target;
      if (
        d.classList &&
        d.classList.contains("mobile-facets__details") &&
        d.hasAttribute("open") &&
        d.querySelector(".mobile-facets__submenu")
      ) {
        openOnly(d);
      }
    },
    true
  );

  // Never let clicking the ACTIVE tab close it — in the master-detail one tab is
  // always open. Native <details> toggles closed on a second click, which empties
  // the right pane and drops the active highlight. Prevent the toggle when the
  // clicked tab is already open; switching to another tab still works.
  form.addEventListener(
    "click",
    function (e) {
      if (!mq.matches) return;
      var summary = e.target.closest && e.target.closest(".mobile-facets__summary");
      if (!summary) return;
      var d = summary.parentElement;
      if (
        d &&
        d.classList &&
        d.classList.contains("mobile-facets__details") &&
        d.querySelector(".mobile-facets__submenu") &&
        d.hasAttribute("open")
      ) {
        e.preventDefault();
      }
    },
    true
  );

  function openFirst() {
    if (!mq.matches) return;
    var all = tabs();
    if (!all.length) return;
    if (!all.some(function (d) { return d.hasAttribute("open"); })) {
      all[0].setAttribute("open", "");
    }
  }

  // Open the first tab when the drawer is opened (its <summary> lives in the
  // menu-drawer disclosure), and once on load in case it's already visible.
  var disclosure = form.closest(".mobile-facets__disclosure");
  if (disclosure) {
    disclosure.addEventListener("toggle", function () {
      if (disclosure.hasAttribute("open")) openFirst();
    });
  }
  openFirst();
})();
